export const speechSynthesisCancel = () => {
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }
};
